/** **** Effet parallax sur contenu ***** */
/* https://github.com/Prinzhorn/skrollr */

const skrollr = require('skrollr')

const maxWidth = 858;

function detectMobile() {
    const deviceAgent = navigator.userAgent.toLowerCase();

    if (deviceAgent.match(/(iphone|ipod|ipad)/)) {
        $('html').addClass('ios');
        $('html').addClass('mobile');
    }

    if (deviceAgent.match(/android/)) {
        $('html').addClass('android');
        $('html').addClass('mobile');
    }

    if (deviceAgent.match(/blackberry/)) {
        $('html').addClass('blackberry');
        $('html').addClass('mobile');
    }

    if (deviceAgent.match(/(symbianos|^sonyericsson|^nokia|^samsung|^lg)/)) {
        $('html').addClass('mobile');
    }
}

(function ($) {
    detectMobile();

    const mobile = $('html').hasClass('mobile');

    /* Ajuster la hauteur des parents */
    function autoHeight(remove) {
        if (remove) {
            const $elements = $('.skrollable')
            $.each($elements, function () {
                $(this).parent().css('minHeight', 0)
            })
        } else {
            const $elements = $('.skrollable')
            $.each($elements, function () {
                const height = $(this).outerHeight() - 25
                $(this).parent().css('minHeight', height)
            })
        }
    }

    function skrollrInit() {
        if (mobile) {
            $('html').addClass('no-skrollr')
            return
        }

        const options = {
            smoothScrolling: false,
            forceHeight: false,
        }
        const theSkrollr = skrollr.get()

        if ($(window).width() <= maxWidth) {
            autoHeight(true)
            $('html').addClass('mobile no-skrollr')
            if (theSkrollr !== undefined && theSkrollr) theSkrollr.destroy()
        } else {
            skrollr.init(options)
            autoHeight(false)
        }
    }

    skrollrInit()

    $(window).on('resize', () => {
        skrollrInit()
    })
}(jQuery))
